import { render, staticRenderFns } from "./ProjectTeamMembers.vue?vue&type=template&id=5624f962&scoped=true&"
import script from "./ProjectTeamMembers.vue?vue&type=script&lang=js&"
export * from "./ProjectTeamMembers.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTeamMembers.vue?vue&type=style&index=0&id=5624f962&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5624f962",
  null
  
)

export default component.exports